export const state = {
  cohorts: [],
  analytics: {
    active_members: 0,
    completed_tasks: 0,
    completed_tasks_change: 0,
    pending_tasks: 0,
    pending_tasks_change: 0,
    completion_rate: 0,
    completion_rate_change: 0,
    task_distribution: {
      completed: 0,
      completed_change: 0,
      not_started: 0,
      not_started_change: 0,
      in_progress: 0,
      in_progress_change: 0,
    },
    top_performing_members: [],
  },
  task_distribution: [
    {
      color: "#67B999",
      label: "Completed (62%)",
      tooltip: "Number of completed tasks",
      count: 101,
      value: "101 Tasks",
      percentage: 62,
    },
    {
      color: "#E87D35",
      label: "Not Started (15%)",
      tooltip: "Number of not started tasks",
      count: 202,
      value: "202 Tasks",
      percentage: 15,
    },
    {
      color: "#743FE3",
      label: "In Progress (23%)",
      tooltip: "Number of in progress tasks",
      count: 101,
      value: "101 Tasks",
      percentage: 23,
    },
  ],
  engagement_metrics: [
    {
      color: "#67B999",
      label: "High Engagement (42%)",
      percentage: 42,
      value: "10 Members",
    },
    {
      color: "#F6B61F",
      label: "Medium Engagement (33%)",
      percentage: 33,
      value: "8 Members",
    },
    {
      color: "#FF6034",
      label: "Low Engagement (25%)",
      percentage: 25,
      value: "6 Members",
    },
  ],
  top_performing_members: [
    {
      name: "John Doe",
      completion_rate: 42,
      tasks_completed: 10,
      tasks_pending: 5,
      last_active: "1 hour ago",
    },
    {
      name: "Jane Doe",
      completion_rate: 75,
      tasks_completed: 10,
      tasks_pending: 5,
      last_active: "3 hours ago",
    },
    {
      name: "John Doe",
      completion_rate: 25,
      tasks_completed: 10,
      tasks_pending: 5,
      last_active: "5 hours ago",
    },
    {
      name: "John Doe",
      completion_rate: 25,
      tasks_completed: 10,
      tasks_pending: 5,
      last_active: "30 minutes ago",
    },
    {
      name: "John Doe",
      completion_rate: 25,
      tasks_completed: 10,
      tasks_pending: 5,
      last_active: "1 day ago",
    },
  ],
};

export const mutations = {
  setCohort(state, cohort) {
    state.cohorts = cohort;
  },
  setAnalytics(state, analytics) {
    // Only cap completion_rate at 100
    if (typeof analytics.completion_rate === "number") {
      analytics.completion_rate = Math.min(analytics.completion_rate, 100);
    }

    // Cap completion_rate in top_performing_members
    if (Array.isArray(analytics.top_performing_members)) {
      analytics.top_performing_members.forEach((member) => {
        if (typeof member.completion_rate === "number") {
          member.completion_rate = Math.min(member.completion_rate, 100);
        }
      });
    }

    state.analytics = analytics;
  },
};

export const actions = {
  async fetchCohorts({ commit }) {
    try {
      const response = await this.$axios.$get(
        `${localStorage.getItem("organizationId")}/groups`
      );
      commit("setCohort", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchAnalytics({ commit }, { cohortId, month, year }) {
    try {
      const organizationId = localStorage.getItem("organizationId");

      let endpoint = `${organizationId}/groups`;

      if (cohortId) {
        endpoint = `${organizationId}/groups/${cohortId}`;
      }

      endpoint += `/analytics?month=${month}&year=${year}`;

      const response = await this.$axios.$get(endpoint);
      const analyticsData = response.data || response;

      commit("setAnalytics", analyticsData);
      return analyticsData;
    } catch (error) {
      console.error("Error fetching analytics:", error);
      throw error;
    }
  },
  async setGroupsAnalytics({ commit }, analytics) {
    commit("setAnalytics", analytics);
  },
};

export const getters = {
  getCohorts: (state) => {
    return state.cohorts;
  },
  getAnalytics: (state) => {
    return state.analytics;
  },
  getTaskDistribution: (state) => {
    return state.analytics.task_distribution;
  },
  getEngagementMetrics: (state) => {
    return state.engagement_metrics;
  },
  getTopPerformingMembers: (state) => {
    return state.analytics.top_performing_members;
  },
};
